import { deleteDoc, doc } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { removePushNotificationTokenDate } from 'shared/services/local-storage';

import {
  CollectionOptions,
  getCollection,
  getUidByPushNotificationToken,
  removePushNotificationToken,
} from './helpers';

export const deletePushToken = async (token: string) => {
  const tokenDoc = doc(getCollection(CollectionOptions.FcmTokens), token);
  const uid = getUidByPushNotificationToken(token);

  deleteDoc(tokenDoc).catch((error) =>
    logFirestoreWriteError({
      op: FirestoreWriteOp.DeletePushToken,
      error,
      docPath: tokenDoc.path,
      uid: uid ?? undefined,
    }),
  );

  // clear token from local storage
  if (!uid) {
    return;
  }
  removePushNotificationToken(uid);
  removePushNotificationTokenDate(uid);
};
